import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { SecurityService } from '../../services/security.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { LoginResponseDTO } from './login.costants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  destroy$ = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private route: Router,
    private networkService: NetworkService,
    private securityService: SecurityService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager 
  ) {}

  ngOnInit(): void {
    if (this.securityService.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      if (currentUser && (currentUser?.group?.groupName === 'BACK_OFFICE_ADMIN' || 
        currentUser?.group?.groupName === 'BACK_OFFICE_AGENT' ||
        currentUser?.group?.groupName === 'FLEET_MANAGER' ||
        currentUser?.group?.groupName === 'FLEET_MANAGER_ADMIN' )
        ){
           this.route.navigate(['/fwp/home']);
      }else{
         this.route.navigate(['/home']);
      }
     
    }
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  login(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      username: this.loginForm?.controls['username'].value,
      password: this.loginForm?.controls['password'].value,
    };
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.login;
    this.networkService
      .postNoToken(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (this.networkService.checkEnvironmentIsDev()) {
            if (
              response &&
              response.statusCode == '200' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');
              let loginResponseDto: LoginResponseDTO = JSON.parse(
                response.body
              );
              this.securityService.setUsername(loginResponseDto.username);
              this.securityService.setSessionLogin(loginResponseDto.session);
              this.route.navigate(['/otpLogin']);
            } else if (
              response &&
              response.statusCode == '500' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(response.body, 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            }
          } else {
            console.log(typeof response);
            if (response && response.session && response.username) {
              this.spinner.hide('sp1');
              let loginResponseDto: LoginResponseDTO = response;
              this.securityService.setUsername(loginResponseDto.username);
              this.securityService.setSessionLogin(loginResponseDto.session);
              this.route.navigate(['/otpLogin']);
            } else if (response && response.length && response.length > 0) {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr(response.toString(), 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            } else {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr('Error during login', 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            }
          }
        },
        (err) => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during login', 'Error', {
            animate: 'slideFromRight',
            timeout: '3000',
          });
        }
      );
  }

  loginDisabled() {
    return this.loginForm?.invalid;
  }

  recoveryPassword() {
    this.route.navigate(['/recoveryPassword']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
